// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {buildSummary} from '../services/summary';
import {findData} from '../services/find-data';

export const findRowData = (report, query) => ({
    data: findData(report, query),
    type: actions.UPDATE_REIMBURSEMENT_SUMMARY_DETAILS_ROW_DATA
});

export const buildSummaryData = report => ({
    data: buildSummary(report),
    type: actions.UPDATE_REIMBURSEMENT_SUMMARY_DETAILS_ROW_DATA
});

export const resetSelectedLeadAccount = () => ({
    type: actions.RESET_REIMBURSEMENT_SUMMARY_SELECTED_LEAD_ACCOUNT
});



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/action-creators/find-data.js